<div class="flex flex-col gap-y-8">
    <div class="relative">
        <interacta-icon
            class="absolute top-0 left-0 size-20"
            [class]="iconConfig().colorClass"
            [icon]="iconConfig().icon"
        />
        <interacta-delta-view
            class="toast-notification-group__first-message typo-sm text-text"
            [delta]="firstMessage()"
            [iconSize]="'small'"
            [maxLines]="clamped() ? 3 : 0"
            (canShowMore)="overflowChanged.emit($event)"
        />
    </div>
    @if (!clamped()) {
        @for (message of restMessages(); track $index) {
            <interacta-separator />
            <interacta-delta-view
                class="min-w-0 typo-sm text-text"
                [delta]="message"
                [iconSize]="'small'"
            />
        }
    }
</div>
